import React from 'react';
import AltNavbar from '../../components/altNavbar/AltNavbar';
import ListCard from '../../components/listCard/ListCard';
import GalleryContainer from '../../containers/galleryContainer/GalleryContainer';
import Hero from '../../containers/hero/Hero';

import header2018 from '../../assets/2018/2018header.webp';
import img2018 from '../event18/images18';
import styles from './Event18.module.css';

const listItems = [
  {
    heading: '推廣「一帶一路」發展戰略，加深香港青年對祖國的認識',
    text: '透過親身考察「一帶一路」沿線城市，讓香港青年了解祖國經濟發展的情況，以及「一帶一路」發展戰略的推動。交流團就「一帶一路」主題制定全方位的學習考察計劃，以加深香港青少年對政策的熟悉。',
    image: img2018.img1,
  },
  {
    heading: '支援基層青年發展，走出香港擴闊視野',
    text: '新來港、少數族裔及基層青少年礙於經濟困難，鮮有機會到內地交流，對個人發展造成局限。他們能夠藉此計劃到內地進行交流學習，了解中國最新發展，協助他們擴闊視野。',
    image: img2018.img4,
  },
];

const images2018 = [
  { img: img2018.img1 },
  { img: img2018.img2 },
  { img: img2018.img3 },
  { img: img2018.img4 },
  { img: img2018.img5 },
  { img: img2018.img6 },
  { img: img2018.img7 },
  { img: img2018.img8 },
  { img: img2018.img9 },
  { img: img2018.img10 },
  { img: img2018.img11 },
  { img: img2018.img12 },
  { img: img2018.img13 },
  { img: img2018.img14 },
  { img: img2018.img15 },
  { img: img2018.img16 },
  { img: img2018.img17 },
  { img: img2018.img18 },
  { img: img2018.img19 },
  { img: img2018.img20 },
  { img: img2018.img21 },
  { img: img2018.img22 },
  { img: img2018.img23 },
  { img: img2018.img24 },
  { img: img2018.img25 },
  { img: img2018.img26 },
  { img: img2018.img27 },
  { img: img2018.img28 },
];

const Event18 = () => {
  return (
    <div>
      <AltNavbar />
      <Hero image={header2018} />
      <div className={styles.textContainer}>
        <p className={styles.text}>
          西安乃古代十三個朝代之首都，文化底蘊深厚，更是古代絲綢之路的起點。此團特意安排西安入城儀式、黃帝陵祭典(國家級非物質文化遺產)、西安城牆健步走、參觀延川梁家河等主題活動，讓香港青年加強對中華歷史文化的學習體驗，提升民族自豪感，燃起愛國情操。
        </p>
        <p className={styles.text}>
          此外，陝西省全力打造外向型經濟的新引擎，力圖將古絲路起點西安建設成「中國孟菲斯」。故而，加緊構建五大中心︰交通商貿物流中心、國際產能合作中心、科技教育中心、國際旅遊中心及區域金融中心。另外，陝西省的文化底蘊深厚，有利於建設人文交流平台，從歷史文化基地、文化考古交流、到中醫藥產業等。
        </p>
      </div>
      {listItems.map((listItem, i) => (
        <ListCard
          key={'list-' + i}
          image={listItem.image}
          heading={listItem.heading}
          text={listItem.text}
        />
      ))}
      <div className={styles.textContainer}>
        <p className={styles.text}>
          是次交流團透過帶領香港青年在交流過程中學習到陝西省在「一帶一路」發展中的擔任角色及作出的成就，從而啟發香港青年把握「一帶一路」上香港的角色，充分發揮青年人的創意，促進內地和香港的共同繁榮發展。
        </p>
      </div>
      <GalleryContainer images={images2018} />
    </div>
  );
};

export default Event18;
